import * as Yup from 'yup';

const editProfileAddressValidationSchema = {
    mainAddressCountry: Yup.string().required('Country is required.'),
    mainAddressAddress1: Yup.string().required('Address is required.'),
    mainAddressCity: Yup.string().required('City is required.'),
    mainAddressState: Yup.string().when('mainAddressCountry', {
        is: val => {
            const input = document.getElementsByName('mainAddressState');
            // input is not in dom (because country does not have states)
            if (input.length === 0) {
                return false;
            }
            return true;
        },
        then: Yup.string().required('State is required.'),
        otherwise: Yup.string().notRequired(),
    }),
    alternateAddressCountry: Yup.string().when(
        ['alternateAddressPreferredMailing', 'alternateAddressPreferredBilling'],
        {
            is: (mailing, billing) => mailing || billing,
            then: Yup.string().required(
                'Country is required when address is set as preferred mailing or billing address.'
            ),
        }
    ),
    alternateAddressAddress1: Yup.string().when(
        ['alternateAddressPreferredMailing', 'alternateAddressPreferredBilling'],
        {
            is: (mailing, billing) => mailing || billing,
            then: Yup.string().required(
                'Address is required when address is set as preferred mailing or billing address.'
            ),
        }
    ),
    alternateAddressCity: Yup.string().when(['alternateAddressPreferredMailing', 'alternateAddressPreferredBilling'], {
        is: (mailing, billing) => mailing || billing,
        then: Yup.string().required('City is required when address is set as preferred mailing or billing address.'),
    }),
    alternateAddressState: Yup.string().when(['alternateAddressPreferredMailing', 'alternateAddressPreferredBilling'], {
        is: (mailing, billing) => {
            const input = document.getElementsByName('alternateAddressState');
            // input is not in dom (because country does not have states)
            if (input.length === 0) {
                return false;
            }
            return mailing || billing;
        },
        then: Yup.string().required('State is required when address is set as preferred mailing or billing address.'),
        otherwise: Yup.string().notRequired(),
    }),
    homeAddressCountry: Yup.string().when(['homeAddressPreferredMailing', 'homeAddressPreferredBilling'], {
        is: (mailing, billing) => mailing || billing,
        then: Yup.string().required('Country is required when address is set as preferred mailing or billing address.'),
    }),
    homeAddressAddress1: Yup.string().when(['homeAddressPreferredMailing', 'homeAddressPreferredBilling'], {
        is: (mailing, billing) => mailing || billing,
        then: Yup.string().required('Address is required when address is set as preferred mailing or billing address.'),
    }),
    homeAddressCity: Yup.string().when(['homeAddressPreferredMailing', 'homeAddressPreferredBilling'], {
        is: (mailing, billing) => mailing || billing,
        then: Yup.string().required('City is required when address is set as preferred mailing or billing address.'),
    }),
    homeAddressState: Yup.string().when(['homeAddressPreferredMailing', 'homeAddressPreferredBilling'], {
        is: (mailing, billing) => {
            const input = document.getElementsByName('homeAddressState');
            // input is not in dom (because country does not have states)
            if (input.length === 0) {
                return false;
            }
            return mailing || billing;
        },
        then: Yup.string().required('State is required when address is set as preferred mailing or billing address.'),
    }),
};

export default editProfileAddressValidationSchema;
